module.exports = __webpack_public_path__ + "static/media/63.75875950.wav";